module.exports = __webpack_public_path__ + "static/media/User Settings.fd0de592.svg";